import {WebCallService} from "@/utilities/services/WebCallService";
import {PathHelper} from "@/utilities/helpers/PathHelper";
import {ErrorLocationType, HttpType} from "@/utilities/enums/Enums";
import ErrorHandler from "@/utilities/helpers/ErrorHandler";
import RecipientList from "@/models/entities/RecipientList";
import GeneralRequest from "@/models/api/GeneralRequest";
import GeneralResponse from "@/models/api/GeneralResponse";

// noinspection DuplicatedCode
export default class RecipientlistService {
    private webCaller: WebCallService;
    private uriHelper: PathHelper;

    constructor(){
        this.webCaller = new WebCallService();
        this.uriHelper = new PathHelper();
    }

    public async getForUser(errorLocationType:ErrorLocationType):Promise<Array<RecipientList>|null>{
        const uri = this.uriHelper.recipientlist.getRecipientlistForUserPath();
        const requestBody = new GeneralRequest(new RecipientList());

        const resp = await this.webCaller.httpSend<GeneralResponse>(HttpType.post, uri, requestBody);
        if (resp === null || resp === undefined || !resp.success) {
            await ErrorHandler.handleResponse(resp, errorLocationType);
            return null;
        }

        return resp.data as Array<RecipientList>;
    }

    public async getBy(listWithSearchProperty:RecipientList, propertyNameToSearchBy:string, errorLocationType:ErrorLocationType):Promise<Array<RecipientList>|null>{
        const uri = this.uriHelper.recipientlist.getByPath();
        const requestBody = new GeneralRequest(listWithSearchProperty, propertyNameToSearchBy);

        const resp = await this.webCaller.httpSend<GeneralResponse>(HttpType.post, uri, requestBody);
        if (resp === null || resp === undefined || !resp.success) {
            await ErrorHandler.handleResponse(resp, errorLocationType);
            return null;
        }

        return resp.data as Array<RecipientList>;
    }

    public async create(recipientList:RecipientList, errorLocationType:ErrorLocationType):Promise<RecipientList|null>{
        const uri = this.uriHelper.recipientlist.getCreateRecipientlistPath();
        const requestBody = new GeneralRequest(recipientList);

        const resp = await this.webCaller.httpSend<GeneralResponse>(HttpType.post, uri, requestBody);
        if (resp === null || resp === undefined || !resp.success) {
            await ErrorHandler.handleResponse(resp, errorLocationType);
            return null;
        }

        return resp.data as RecipientList;
    }

    public async update(recipientList:RecipientList, errorLocationType:ErrorLocationType):Promise<RecipientList|null>{
        const uri = this.uriHelper.recipientlist.getUpdateRecipientlistPath();
        const requestBody = new GeneralRequest(recipientList);

        const resp = await this.webCaller.httpSend<GeneralResponse>(HttpType.post, uri, requestBody);
        if (resp === null || resp === undefined || !resp.success) {
            await ErrorHandler.handleResponse(resp, errorLocationType);
            return null;
        }

        return resp.data as RecipientList;
    }

    public async delete(list:RecipientList, errorLocationType:ErrorLocationType):Promise<boolean|null>{
        const uri = this.uriHelper.recipientlist.getDeleteRecipientlistPath();
        const requestBody = new GeneralRequest(list);

        const resp = await this.webCaller.httpSend<GeneralResponse>(HttpType.post, uri, requestBody);
        if (resp === null || resp === undefined || !resp.success) {
            await ErrorHandler.handleResponse(resp, errorLocationType);
            return null;
        }

        return resp.success;
    }

    public async getRecipientAssociations(list:RecipientList, errorLocationType:ErrorLocationType):Promise<RecipientList|null>{ //TODO type
        const uri = this.uriHelper.recipientlist.getRecipientAssociationsPath();
        const requestBody = new GeneralRequest(list);

        const resp = await this.webCaller.httpSend<GeneralResponse>(HttpType.post, uri, requestBody);
        if (resp === null || resp === undefined || !resp.success) {
            await ErrorHandler.handleResponse(resp, errorLocationType);
            return null;
        }

        return resp.data as RecipientList;
    }

    public async updateRecipientAssociations(recipientList:RecipientList, errorLocationType:ErrorLocationType):Promise<RecipientList|null>{
        const uri = this.uriHelper.recipientlist.getUpdateRecipientAssociationsPath();
        const requestBody = new GeneralRequest(recipientList);

        const resp = await this.webCaller.httpSend<GeneralResponse>(HttpType.post, uri, requestBody);
        if (resp === null || resp === undefined || !resp.success) {
            await ErrorHandler.handleResponse(resp, errorLocationType);
            return null;
        }

        return resp.data as RecipientList;
    }
}